import React, { useState } from "react";
import Checkbox from "./checkbox";
import themePropTypes from "../theme-prop-types";
import {
  EXPANDED_CLASSNAME,
  EXPANDO_OPTION_TEST_IDS
} from "../../utils/constants";

const ExpandoOption = ({ onCheckboxChange, title, options, settings }) => {
  const [isExpanded, setExpanded] = useState(false);

  const drawSelectedQuantity = () => {
    const selectedOptionsCount = options.filter(
      option => option.cell_data.selected
    ).length;
    let selectedQuantity = "";

    if (selectedOptionsCount) {
      selectedQuantity = settings.translations.selected_quantity.replace(
        "%selected_quantity%",
        selectedOptionsCount === options.length
          ? settings.translations.all
          : selectedOptionsCount
      );
    }

    return selectedQuantity;
  };

  const drawOptions = optionsArr => {
    return (
      <div
        className='expando-options-web-sdk'
        data-testid={EXPANDO_OPTION_TEST_IDS.optionsWrapper}
      >
        {optionsArr.map(option => {
          const { cell_data } = option;

          return (
            <Checkbox
              name={cell_data.title}
              label={cell_data.title}
              onChange={() => onCheckboxChange(cell_data.value, title)}
              key={cell_data.title}
              checked={cell_data.selected}
            />
          );
        })}
      </div>
    );
  };

  const expandoHeaderClickHandler = event => {
    event.preventDefault();
    setExpanded(!isExpanded);
  };

  return (
    <div className='expando-option-wrapper-web-sdk'>
      <button
        type='button'
        className={`expando-option-header-web-sdk ${
          isExpanded ? EXPANDED_CLASSNAME : ""
        }`}
        onClick={expandoHeaderClickHandler}
        data-testid={EXPANDO_OPTION_TEST_IDS.button}
      >
        {title}{" "}
        <span className='expando-selected-options-web-sdk'>
          {drawSelectedQuantity()}
        </span>
      </button>
      {isExpanded ? drawOptions(options) : null}
    </div>
  );
};

ExpandoOption.propTypes = themePropTypes.expandoOption;

export default ExpandoOption;
